import { render } from "./TableDialogLeadsData.vue?vue&type=template&id=d6d0dd74&scoped=true"
import script from "./TableDialogLeadsData.vue?vue&type=script&lang=js"
export * from "./TableDialogLeadsData.vue?vue&type=script&lang=js"

import "./TableDialogLeadsData.vue?vue&type=style&index=0&id=d6d0dd74&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6d0dd74"]])

export default __exports__